<template>
  <div class='tablePage'>
    <el-table v-loading='loading' ref='multipleTable' :data='tableData' tooltip-effect='dark' style='width: 100%'
              :header-cell-style='headCellStyle' :height='tableHeight' @selection-change='handleSelectionChange' stripe>
      <el-table-column type='selection' width='50' />
      <el-table-column v-if='isSys' prop='scopeName' :label="$t('public.table_scope')" show-overflow-tooltip />
      <el-table-column prop='name' :label="$t('device.gateway_name')" show-overflow-tooltip width='200'>
        <template #default='{ row }'>
          <DeviceCode :device='row'>
            <template #icon='{device}'>
              <i v-icon:theme="['gatewayTypeConvert', device.type]" v-if='!$slots.icon'></i>
            </template>
            <template #name='{device}'>
              <el-popover placement='top-start' width='auto' trigger='hover'>
                <v-popoer :rowData='device' :typeWay='$attrs.sensorWay' />
                <span slot='reference' :class="{'bolder':device.status === ENUM_SENSOR_STATUS.OFFLINE}">
                            {{ device.name }}
                        </span>
              </el-popover>
            </template>
          </DeviceCode>
        </template>
      </el-table-column>
      <el-table-column prop='mac' label='mac' show-overflow-tooltip />
      <el-table-column prop='carrierName' width='230' :label="$t('public.table_carrier')">
        <template #default='{row}'>
          <CardSwipper :key='Math.random()' :list='row.carrierList'>
            <template #title='{item}'>
              {{ item.sceneName }}
            </template>
            <template #default='{item}'>
              <div class='uk-flex'>
                <div style='width: 30px' class='bd-r uk-flex uk-flex-center'>
                  <i :class='carrierTypeConvert(item.type).icon'
                     class='uk-margin-remove'
                     :title='carrierTypeConvert(item.type).title' style='margin-right: 5px; cursor: pointer'
                     @click='handleCarrierFn(item)'></i>
                </div>
                <div class='uk-flex-1'>
                  {{ item.carrierName }}
                </div>
              </div>
            </template>
          </CardSwipper>
        </template>
      </el-table-column>

      <el-table-column prop='updateTime' :label="$t('public.update_time')" show-overflow-tooltip>
        <template #default='{row}'>
          {{ $timetransition(row.updateTime) }}
        </template>
      </el-table-column>
      <el-table-column prop='optare' fixed='right' :label="$t('public.table_operation')" width='110' align='center'>
        <template #default='{ row }'>
          <el-button type='text' size='small' v-for='item in optareBtn' :key='item.id' :title='$t(item.title)'
                     :icon='item.icon' @click='handle(item.method, row)'></el-button>
          <!-- v-has="item.vHas" -->
        </template>
      </el-table-column>
    </el-table>
    <MonitorDialog :visible.sync='dialogVisible' :carrier-info='carrierDetail'></MonitorDialog>
  </div>
</template>

<script>
import { carrierDetail } from '@/api/modules/carrier.js'
import prover from '../components/Proper.vue'
import { carrierTypeConvert, configStatusConvert, equiStatusConvert, gatewayTypeConvert } from '@/utils/convert'
import CardSwipper from '@/components/CardSwipper/CardSwipper.vue'
import MonitorDialog from '@/pages/equipment/publicCom/MonitorDialog.vue'
import { getIsSys } from '@/utils/permission'
import DeviceCode from '@/pages/equipment/publicCom/DeviceCode.vue'
import { ENUM_DEVICE_STATUS, ENUM_DEVICE_WAY } from '@/common/enum/forward/device'

export default {
  props: ['loading', 'tableData'],
  computed: {
    ENUM_SENSOR_STATUS () {
      return ENUM_DEVICE_STATUS
    },
    /** 用于表示当前登录用户属于什么类型的角色 */
    isSys () {
      return getIsSys()
    }
  },
  components: {
    DeviceCode,
    MonitorDialog,
    'v-popoer': prover,
    CardSwipper
  },
  data () {
    return {
      gatewayTypeConvert,
      equiStatusConvert,
      configStatusConvert,
      carrierTypeConvert,
      tableHeight: '100%',
      optareBtn: [
        {
          id: 1,
          title: $t('public.stop'),
          icon: 'el-icon-video-pause',
          vHas: [],
          method: 'stopUseFn'
        },
        {
          id: 2,
          title: $t('public.config'),
          icon: 'el-icon-setting',
          vHas: [],
          method: 'configFn'
        },
        {
          id: 4,
          title: 'public.details',
          icon: 'el-icon-tickets',
          vHas: [],
          method: 'detailFn'
        }
      ],

      isLoading: false,
      dialogVisible: false,
      carrierDetail: null,
      typeWay: ENUM_DEVICE_WAY.BIND
    }
  },

  methods: {
    handleCarrierFn (item) {
      carrierDetail(item.type, item.id)
        .then(({ result }) => {
          this.dialogVisible = true
          this.isLoading = true
          this.carrierDetail = result
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handleSelectionChange (row) {
      this.$emit('choozeTable', row)
    },
    /** 查找监测点详情 */
    carrierDetailFn (type, carrierId) {
      this.dialogVisible = true
      this.isLoading = true
      carrierDetail(type, carrierId)
        .then(({ result }) => {
          this.carrierDetail = result
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handle (method, row) {
      this.$emit(method, row)
    },
    handleClose () {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang='scss' scoped>
.tablePage {
  height: calc(100% - 60px);
}
</style>
